export default {
  loading: 'Loading...',
};
